export function extractBooleanFromEnvironmentVariable(environmentVariable: String) {
    return environmentVariable.toLowerCase() === "true"
}